// components/ProtectedRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useUser } from '../context/UserContext';
import Layout from './Layout';
import { isRacingOnly, racingRedirect } from '../racing/config';

const UNGATED_PATHS = ['/profile', '/settings', '/subscription-required'];

export default function ProtectedRoute({ children, currentPage }) {
  const { isAuthenticated, loading: authLoading, signOut } = useAuth();
  const { needsOnboarding, loading: userLoading, currentUser, currentCompany, hasAccess } = useUser();
  const location = useLocation();

  const loading = authLoading || userLoading;

  if (loading) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (!currentCompany && !['/settings', '/profile'].includes(location.pathname)) {
    return <Navigate to="/settings" replace />;
  }

  const workspaceRedirect = racingRedirect(currentCompany, location.pathname);
  if (workspaceRedirect) return <Navigate to={workspaceRedirect} replace />;

  if (!hasAccess && !UNGATED_PATHS.includes(location.pathname)) {
    return <Navigate to="/subscription-required" replace />;
  }

  return (
    <Layout
      workspace={isRacingOnly(currentCompany) ? 'racing' : 'ames'}
      currentUser={currentUser}
      currentCompany={currentCompany}
      onSignOut={signOut}
      currentPage={currentPage}
    >
      {children}
    </Layout>
  );
}
